import {
  HTTP_BUDGETMONTH_FETCHING,
  HTTP_BUDGETMONTH_SUCCESS,
  HTTP_BUDGETMONTH_FAILED,
  HTTP_UPDATEBUDGETMONTH_FETCHING,
  HTTP_UPDATEBUDGETMONTH_SUCCESS,
  HTTP_UPDATEBUDGETMONTH_FAILED,
  server,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import Axios from "axios";
//   import { async } from "q";

export const setStateBudgetMonthToFetching = () => ({
  type: HTTP_BUDGETMONTH_FETCHING,
});

export const setStateBudgetMonthToSuccess = (payload) => ({
  type: HTTP_BUDGETMONTH_SUCCESS,
  payload,
});

export const setStateBudgetMonthToFailed = (payload) => ({
  type: HTTP_BUDGETMONTH_FAILED,
});

export const setStateUpdateBudgetmonthToFetching = () => ({
  type: HTTP_UPDATEBUDGETMONTH_FETCHING,
});

export const setStateUpdateBudgetmonthToSuccess = (payload) => ({
  type: HTTP_UPDATEBUDGETMONTH_SUCCESS,
  payload,
});

export const setStateUpdateBudgetmonthToFailed = (payload) => ({
  type: HTTP_UPDATEBUDGETMONTH_FAILED,
});

export const getBudgetMonth = (budgetsdsid, budgetsdaccid) => {
  return async (dispatch) => {
    dispatch(setStateBudgetMonthToFetching());

    try {
      const result = await httpClient.get(
        `${server.BUDGETMONTH_URL}/${budgetsdsid}/${budgetsdaccid}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(setStateBudgetMonthToSuccess(result.data));
    } catch (error) {
      // console.log("aaaaa");
      dispatch(setStateBudgetMonthToFailed());
    }
  };
};

export const updateBudgetmonthById = (budgetsdsid, budgetsdaccid, item) => {
  return async (dispatch) => {
    dispatch(setStateUpdateBudgetmonthToFetching());
    try {
      // const result = await httpClient.put(
      await Axios.put(
        `${server.UPDATEBUDGETMONTH_URL}/${budgetsdsid}/${budgetsdaccid}`,
        item,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(setStateUpdateBudgetmonthToSuccess("success"));
    } catch (error) {
      dispatch(setStateUpdateBudgetmonthToFailed());
    }
  };
};
